import React from 'react';
import { CtaButton } from './CtaButton';
import { RatingProof } from './RatingProof';
const chips = ['6 Volumes', '57 Sessions', '300 Pages', '2 · 3 · 4-hour formulas', '5 Bonuses'];
const micro = ['Instant PDF download', 'Money-back guarantee', 'Print it or run it from your VTT'];
export function Hero() {
  return <section className="w-full bg-plum-deep" data-id="element-102" data-mp="4njqyesgw3d3">
      <div className="max-w-6xl mx-auto px-5 pt-8 pb-16 sm:pt-12 sm:pb-20" data-id="element-103" data-mp="1297esbauxdd0">
        <div className="grid items-center gap-8 lg:grid-cols-[1.05fr_.95fr] lg:gap-12" data-id="element-104" data-mp="1274n7mu23c66">
          <div data-id="element-105" data-mp="x8b6lljh351s">
            <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-106" data-mp="sbb0xbqjc4b7">
              The Paid Table Loop · for Game Masters who get paid
            </p>
            <h1 className="mt-4 font-display font-semibold text-white text-[36px] leading-[1.08] tracking-tight sm:text-5xl md:text-[56px]" data-id="element-107" data-mp="nbydopvr4v83">
              Your whole year of paid tables,{' '}
              <span className="text-gold" data-id="element-108" data-mp="3814alm6t1smr">already run-sheeted.</span>
            </h1>
            <p className="mt-5 max-w-xl text-base sm:text-lg text-white/75" data-id="element-109" data-mp="3j9tymsm91cin">
              Paid Table Ready is six volumes with 57 table-ready 5E sessions —
              one-shots, campaign arcs and event tables — each on a one-page Run
              Sheet you read in about 20 minutes. Open the week, pick your
              length, run the table.
            </p>
            <ul className="mt-6 flex flex-wrap gap-2" data-id="element-110" data-mp="30hho3ilfz4xf">
              {chips.map(chip => <li key={chip} className="rounded-full border border-plum-line px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-white/70" data-id="element-111" data-mp="3599hs1zw9qrs">
                  {chip}
                </li>)}
            </ul>
          </div>

          <div className="overflow-hidden rounded-2xl border border-plum-line shadow-cover" data-id="element-112" data-mp="2hinc2hdd4iky">
            <img src="https://cdn.magicpatterns.com/uploads/jtzcKXNfQmETCmbLHSyptC/mockup-paid-table-ready-the-5e-megapack-for-game-masters-who-get-paid.png" alt="Paid Table Ready: The 5E Megapack for Game Masters Who Get Paid — book cover on a candlelit tavern table" className="block aspect-square w-full object-cover" data-id="element-113" data-mp="2lla5untlgdks" />
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-114" data-mp="ddne9xklijhu">
          <div className="w-full max-w-md" data-id="element-115" data-mp="db2f5gbomhns">
            <CtaButton data-id="element-116" data-mp="1b15q5h9k01q2">Get Paid Table Ready</CtaButton>
          </div>
          <div className="mt-5" data-id="element-117" data-mp="161t1qs31amld">
            <RatingProof data-id="element-118" data-mp="162uer23m1j5q" />
          </div>
          <figure className="mt-5 max-w-md text-center" data-id="element-119" data-mp="15zq2dhfzrh3z">
            <blockquote className="text-sm italic text-white/80" data-id="element-120" data-mp="111ol9224lrv5">
              “I currently run six weekly campaigns. That’s upwards of 50hrs of
              work a week, and I only get paid for about 18 of them.”
            </blockquote>
            <figcaption className="mt-1.5 text-xs text-white/50" data-id="element-121" data-mp="3lqugltxj6h7p">
              — a paid GM, public forum, 2024–25
            </figcaption>
          </figure>
          <p className="mt-4 max-w-md text-center text-sm text-white/70" data-id="element-122" data-mp="1xacgp6hknput">
            Written for GMs who run paid tables every week — online or in
            person. 5E compatible, works on any VTT, no subscription.
          </p>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-123" data-mp="268ofhvsldtyc">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-124" data-mp="2g02iwennzdwr">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-125" data-mp="2g1wtp0581pn4" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}